import * as React from "react";
import { Menu } from "@models/menu";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { Divider, Modal, Table, Button } from "antd";
import Message from "@constants/message";
import MenuForm from "@components/menus/Form";
import { PaginationDefaultParams } from "@components/custom/Paginator";
import { NavLink } from "react-router-dom";

type Props = {
  data: Menu[];
  loading: boolean;
  deleteFn: (item: Menu) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const MenusTable: React.FC<Props> = props => {
  const { data, loading, currentPage, deleteFn, intl } = props;
  const { formatMessage } = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteMenu = (item: Menu): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`} />,
      width: 150,
      dataIndex: "title",
      key: "title"
    },
    // {
    //   title: <FormattedMessage id="app.url" defaultMessage={`Url`} />,
    //   dataIndex: "url",
    //   key: "url"
    // },
    {
      title: "",
      key: "actions",
      // width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/menus/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`} />
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`} />

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteMenu(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`} />
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(MenusTable);
